// Generated by purs version 0.15.15
import * as Ouroboros_Programs_Capabilities from "../Ouroboros.Programs.Capabilities/index.js";
import * as Ouroboros_Programs_Controllers_AdminPlan from "../Ouroboros.Programs.Controllers.AdminPlan/index.js";
var readOption = function (v) {
    return v;
};
var buildAdminPlanViewProps = function (input) {
    return {
        plan: readOption(Ouroboros_Programs_Capabilities.optionStateHandleRead(input.kernel.plan)),
        loadError: readOption(Ouroboros_Programs_Capabilities.optionStateHandleRead(input.kernel.loadError)),
        onInit: Ouroboros_Programs_Controllers_AdminPlan.buildOnInit(input.kernel)
    };
};
export {
    buildAdminPlanViewProps
};
//# sourceMappingURL=index.js.map
